import axios from 'axios';
import type {
  CreateProtocolRequest,
  DeleteProtocolRequest,
  GetProtocolHistoryRequest,
  GetProtocolHistoryResponse,
  GetProtocolListRequest,
  GetProtocolListResponse,
  UpdateProtocolMetaRequest,
  UpdateProtocolTargetRequest,
} from '@/types/protocol';

/**
 * 创建执行标识
 */
export function createProtocolApi(data: CreateProtocolRequest) {
  return axios.post<void>('/api/console/workspace/v1/protocol/create', data);
}

/**
 * 删除执行标识
 */
export function deleteProtocolApi(data: DeleteProtocolRequest) {
  return axios.post<void>('/api/console/workspace/v1/protocol/delete', data);
}

/**
 * 查询执行标识历史变更记录
 */
export function getProtocolHistoryApi(data: GetProtocolHistoryRequest) {
  return axios.post<GetProtocolHistoryResponse>(
    '/api/console/workspace/v1/protocol/history',
    data
  );
}

/**
 * 查询工作空间下的执行标识列表
 */
export function getProtocolListApi(data: GetProtocolListRequest) {
  return axios.post<GetProtocolListResponse>(
    '/api/console/workspace/v1/protocol/list',
    data
  );
}

/**
 * 更新执行标识基础信息（名称/描述等）
 */
export function updateProtocolMetaApi(data: UpdateProtocolMetaRequest) {
  return axios.post<void>(
    '/api/console/workspace/v1/protocol/update_meta',
    data
  );
}

/**
 * 更新执行标识当前指向的工作流目标
 */
export function updateProtocolTargetApi(data: UpdateProtocolTargetRequest) {
  return axios.post<void>(
    '/api/console/workspace/v1/protocol/update_target',
    data
  );
}
